<template>
  <section class="action-selector well" v-bind:disabled="!authorized">
    <div class="radio" v-for="(action, index) in actions" v-bind:key="action.id">
      <label>
        <input
          type="radio"
          v-bind:checked="index === indexOfSelectedAction"
          v-on:input="$emit('selectAction', index)"
        >
        <span class="color-sample" v-bind:class="action.color"></span>
        <input
          v-if="!action.immutableName"
          type="text"
          v-bind:value="action.name"
          v-on:click="$emit('selectAction', index)"
          v-on:input="$emit('setNameOfAction', { name: $event.target.value, index: index })"
        >
        <span v-else>{{ action.name }}</span>
        <button
          title="Apply to all unselected hands"
          class="btn btn-default btn-xs"
          v-on:click="$emit('applyToAllUnselectedHands', action.color)"
        >
          Apply
        </button>
        <span
          v-if="!action.immutableName"
          class="close"
          v-on:click.prevent="$emit('removeAction', index)"
        >
          &times;
        </span>
        <span v-if="action.name !== 'Not possible'">{{ $store.getters['rangeConstructor/percentageForAction'](action.color) }}%</span>
      </label>
    </div>
    <hr>
    <button
      class="btn btn-default"
      v-bind:disabled="actions.length === 8"
      v-on:click="$emit('addAction')"
    >
      Add
    </button>
  </section>
</template>

<script>
export default {
  name: 'action-selector',
  props: ['actions', 'indexOfSelectedAction', 'authorized'],
};
</script>

<style lang="scss" scoped>
  @import "node_modules/bootstrap-sass/assets/stylesheets/bootstrap/variables";

  .action-selector {
    display: inline-block;
    vertical-align: top;
    margin-left: 20px;

    .color-sample {
      display: inline-block;
      height: 10px;
      width: 10px;

      &.red { background-color: #e27c79; }
      &.blue { background-color: #337ab7d4; }
      &.green { background-color: #80c780; }
      &.yellow { background-color: #e2cd0ed9; }
      &.orange { background-color: #ff9800e0; }
      &.purple { background-color: #9c27b0c7; }
      &.brown { background-color: #ab6146d4; }
      &.impossible-range-constructor {
        color: lightgrey;
        background-color: white;
      }
      &.possible-but-deselected {
        color: auto;
        background-color: lighten($gray-base, 95%);;
      }
    }

    .close {
      margin-left: 5px;
    }

    &[disabled="disabled"] {
      pointer-events: none;
    }
  }

  @media (max-width: 991px) {
    .action-selector {
      margin-top: 25px;
      margin-left: 0px;
      display: block;
      max-width: 353px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/range-constructor/action-selector.vue